import type { FC, ReactNode } from "react";
import { Breakpoint, useMediaQuery } from "@stubhub/broadway-providers";
import { useContent } from "src/shared/components/content";
import type { Location } from "src/types/shared/cookies";
import { StyledHeaderSection, StyledLocationSelector, StyledText } from "./styled-components";

interface Props {
  headerContent: ReactNode;
  location: Maybe<Location>;
  placement: string | undefined;
  setLocation: ((location: Location) => void) | undefined;
}

/**
 * Reusable Header Section for LocCarouselListSection
 */
export const HeaderSection: FC<Props> = ({ headerContent, location, placement, setLocation }) => {
  const isMobile = !useMediaQuery(Breakpoint.Tablet);
  const locationSelectorPlaceholderContent = useContent("cid$#1904153#");

  return (
    <StyledHeaderSection>
      <StyledText>{headerContent}</StyledText>
      <StyledLocationSelector
        fixedFlyout={isMobile}
        location={location}
        onLocationChange={setLocation}
        placeholder={locationSelectorPlaceholderContent}
        placement={placement}
        whiteBackground
      />
    </StyledHeaderSection>
  );
};
